export const environment = {
  production: false,
  baseURL: 'https://azeapp.com/',
  // baseURL: 'http://staging.azelerator.com/',

  LOCATION_API: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=',
  GOOGLE_APIKEY: 'AIzaSyDK2EXp99Tl6jH-RxjJZ-rmSI9P-Ym3hQI',
  userName: '155956',
  password: '12345678',
  packageName: 'vvd.retailers.app',
  Logging: {
    IsFirebase: true, //Firebase logging is required or not
    LogLevel: 'Warn',
  },
};
